import { InfiniteTable } from '@/components/_common';
import StatusTag from '@/components/_common/StatusTag';
import {
  CashMovement,
  CashMovementListResponse,
} from '@/core/domain/financial/BoxMovement/BoxMovement.types';
import formatterPrice from '@/utils/number/formatterPrice';
import { flatInfiniteData } from '@/utils/request/flatInfiniteData';
import { getTableScrollX } from '@/utils/table';
import { ColumnsType } from 'antd/lib/table';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import ListTableFooter from './ListTableFooter';
import { UseInfiniteQueryResult } from 'react-query';

interface Props {
  cashMovementList: UseInfiniteQueryResult<CashMovement, unknown>;
}
const CashMovementList: React.FC<Props> = ({ cashMovementList }) => {
  const intl = useIntl();

  const [balance, setBalance] = useState<CashMovement>();

  const { data, fetchNextPage, hasNextPage, isLoading, isFetching } =
    cashMovementList;

  const cashMovements = flatInfiniteData(data);

  useEffect(() => {
    if (data) {
      setBalance(data.pages.at(-1));
    }
  }, [data]);

  const columns: ColumnsType<CashMovementListResponse> = [
    {
      key: 'bankingEntryCode',
      dataIndex: 'bankingEntryCode',
      title: 'Lanç. bancário',
      ellipsis: true,
      width: 100,
    },
    {
      key: 'code',
      dataIndex: 'code',
      title: intl.formatMessage({
        id: 'cashMovement.form.table.installmentCode',
      }),
      ellipsis: true,
      width: 100,
    },
    {
      key: 'launch',
      dataIndex: 'launch',
      title: intl.formatMessage({
        id: `cashMovement.form.table.launch`,
      }),
      ellipsis: true,
      width: 100,
      render: (value) => (value ? moment(value).format('DD/MM/YYYY') : '-'),
    },
    {
      key: 'description',
      dataIndex: 'description',
      title: intl.formatMessage({
        id: `cashMovement.form.table.description`,
      }),
      ellipsis: true,
      width: 330,
    },
    {
      key: 'documentNumber',
      dataIndex: 'documentNumber',
      title: intl.formatMessage({
        id: `cashMovement.form.table.documentNumber`,
      }),
      width: 180,
    },
    {
      key: 'entry',
      dataIndex: 'value',
      title: intl.formatMessage({
        id: `cashMovement.form.table.entry`,
      }),
      ellipsis: true,
      width: 160,
      render: (value, row) => {
        if (row.type === 'Entrance') {
          return (
            <div style={{ color: 'rgb(160, 206, 51)' }}>
              {formatterPrice(value)}
            </div>
          );
        }
      },
    },
    {
      key: 'exit',
      dataIndex: 'value',
      title: intl.formatMessage({
        id: `cashMovement.form.table.exit`,
      }),
      ellipsis: true,
      render: (value, row) => {
        if (row.type === 'Exit') {
          return (
            <div style={{ color: 'rgb(207, 74, 29)' }}>
              {formatterPrice(value)}
            </div>
          );
        }
      },
      width: 160,
    },
    {
      key: 'refund',
      dataIndex: 'refund',
      title: '',
      render: (_, row) => {
        if (row.refund) {
          return <StatusTag label="Estornado" color="yellow" />;
        }
      },
      width: 80,
    },
  ];
  return (
    <InfiniteTable<CashMovementListResponse>
      dataSource={cashMovements}
      fetchNextPage={fetchNextPage}
      hasNextPage={hasNextPage}
      loading={isLoading || isFetching}
      size="middle"
      rowKey={(row) => row.code}
      columns={columns}
      scroll={{ x: getTableScrollX(columns) }}
      footer={() => <ListTableFooter balance={balance} />}
    />
  );
};

export default CashMovementList;
